import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import AlertBanner from '../../ui/alert-banner/alert-banner';
import { injectAppStale, RELOAD_APP } from '../app-stale';

@Component({
  selector: 'app-update-banner',
  imports: [DxButtonModule, AlertBanner],
  templateUrl: './app-update-banner.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class AppUpdateBanner {
  protected readonly isStale = injectAppStale();
  protected readonly reload = inject(RELOAD_APP);
}
